export default "__VITE_ASSET__BAhG5BOR__"